import { Injectable } from "@angular/core";

function getWindow(): unknown {
  return window;
}

@Injectable()
export class WindowRefService {
  get nativeWindow(): unknown {
    return getWindow();
  }
}
